import React, { useContext, useEffect, useState } from 'react'
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { Badge } from "primereact/badge";
import { formatDateTime } from "../../config/Config";
import { votersService } from "../../services/VotersService";
import "./VoterAuditSearch.scss";
import { VoterDialog } from "./VoterDialog";
import { TabPanel, TabView } from "primereact/tabview";
import { ApplicationSearch } from "./../applications/Search";
import ViewApplication from "../applications/ViewApplication";
import { formatDate } from "../../config/Config";
import { NULL } from "sass";
import PrintOutAction from "../reports/PrintOutAction";
import { PrintOut } from './../reports/PrintOut'
import { reportService } from '../../services/ReportService'
import { AppDB } from '../../App'
import MultiFilterSearch from '../../componets/MultiFilterSearch';

export const VoterAuditSearch = () => {
	// const toast = useRef(null);
	const [showDialog, setShowDialog] = useState(false);
	const [loading, setLoading] = useState(false);
	const [showApplication, setShowApplication] = useState(false);
	const [applicationID, setApplicationID] = useState(null);
	var [showReportDialog, setReportShowDialog] = useState(false)
	var [currentReport, setCurrentReport] = useState(false)
	var [showTable, setShowTable] = useState(false)
	var [base64, setBase64] = useState("")
	var { toast } = useContext(AppDB);

	var [data, setData] = useState([]);
	var [applications, setApplications] = useState([]);
	var [selectedItem, setSelectedItem] = useState(null);
	var [idNumber, setIdNumber] = useState("");

	const filters = {
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		name: {
			operator: FilterOperator.AND,
			constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
		}
	};

	const [selectedType, setSelectedType] = useState(null);
	const getVoterAudit = async () => {
		setSelectedItem(null);
		setLoading(true);

		try {
			const data = await votersService.getAuditByIDNumber(idNumber);
			setData(data);
		} catch (error) {
			console.error("Error fetching voter:", error);
		} finally {
			setLoading(false);
		}
	};

	const getHistory = async () => {
		setSelectedItem(null);
		setLoading(true);

		try {
			const response = await votersService.getHistoryByIDNumber(idNumber);
			const data = [];

			if (response.success) {
				response.voter.active = true;
				setApplications(response.applications);
				data.push(response.voter);

				for (const audit of response.audits) {
					audit.active = false;
					data.push(audit);
				}
			}
			console.log(data)
			setData(data);
		} catch (error) {
			console.error("Error fetching voter:", error);
		} finally {
			setLoading(false);
		}
	};

	const getHistoryByID = async (idNumber) => {
		setSelectedItem(null);
		setLoading(true);

		try {
			const response = await votersService.getHistoryByIDNumber(idNumber);
			const data = [];

			if (response.success) {
				response.voter.active = true;
				setApplications(response.applications);
				data.push(response.voter);

				for (const audit of response.audits) {
					audit.active = false;
					data.push(audit);
				}
			}
			console.log(data)
			setData(data);
		} catch (error) {
			console.error("Error fetching voter:", error);
		} finally {
			setLoading(false);
		}
	};

	const header = (name) => (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">
				<b>{name}</b>
			</h5>
		</div>
	);
	const columnConfigs = {
		Registration: [{ field: "registration.village.name", header: "Village" }],
		Transfer: [
			{ field: "transfer.fromVillage.name", header: "From Village" },
			{ field: "transfer.toVillage.name", header: "From Village" }
		]
	};

	var searchCriteria = [
		{
			name: "National ID",
			val: 0
		},
		{
			name: "Registration Number",
			val: 1
		}
	];

	const onHideApplication = () => {
		setShowApplication(false);
		setSelectedApplication(null);
	};
	var [activePageIndex, setActivePageIndex] = useState(0);
	var [selectedApplication, setSelectedApplication] = useState(null);

	const villageTemplate = (rowData) => {
		// if (rowData.applicationTypeID == 1) {
		// 	return rowData.registration.village.name;
		// }

		return `${rowData?.village?.code}-${rowData?.village?.name}`;
	};
	function onGenerateRport(isInternal, voterID) {
		setLoading(true)
		reportService
			.getReport({
				"ReportID": 9,
				"VoterID": voterID,
				"IsInternal": isInternal
			})
			.then((res) => {
				setLoading(false)
				if (res?.success === true) {
					toast.show({ severity: "success", summary: "Success", detail: "Report Loaded", life: 5000 });
					setBase64(res.data)
				} else {
					toast.show({ severity: "error", summary: "", detail: "No Data Found", life: 3000 });
				}

			});
	}

	return (
		<div className="grid">
			<PrintOut base64={base64} setBase64={setBase64} showDialog={showReportDialog} setShowDialog={setReportShowDialog} />
			<PrintOutAction showDialog={showReportDialog} setShowDialog={setReportShowDialog} applicationID={applicationID} currentReport={currentReport} />
			<div className="col-12 ">
				<Toast ref={toast} />


				<div className="card  p-align-stretch vertical-container"

					style={{
						minHeight: "calc(100vh - 9rem)",
						// display: showTable ? "none" : "block" 
					}}>

					<MultiFilterSearch
						includeEligible={true}
						label='Elector Search'
						onChange={res => {
							getHistoryByID(res.idNumber)
						}}
						onStateChange={(state) => {
							setShowTable(!state)
						}}
					/>

					<TabView style={{ display: showTable ? "none" : "block" }} >
						{/* disabled={pageIndex == 0 ? false : true} */}
						<TabPanel header={header("Elector")}>
							<DataTable
								loading={loading}
								size="small"
								scrollable={true}
								value={data}
								dataKey="id"
								paginator
								rows={10}
								rowsPerPageOptions={[5, 10, 25]}
								className="datatable-responsive"
								currentPageReportTemplate="Showing {first} to {last} of {totalRecords} elector"
								emptyMessage="No elector data."
								responsiveLayout="scroll"
								resizableColumns
								columnResizeMode="expand"
								filters={filters}
								filterDisplay="menu"
								globalFilterFields={["DateRegistered_s"]}
							>
								<Column style={{ width: "100px" }} filterField="Surname" field="surname" header="Surname"></Column>
								<Column style={{ width: "100px" }} field="firstname" header="First name"></Column>
								{/* <Column style={{ width: "100px" }} field="village.registrationCentre" header="Voting Station"></Column> */}
								<Column style={{ width: "100px" }} field="village.name" header="Village" body={villageTemplate}></Column>
								<Column
									style={{
										overflow: "visible" // Set overflow to visible to prevent hidden content
									}}
									field="auditDate"
									body={(e) => <>
										{/* {console.log(e)} */}
										{formatDateTime(e?.auditDate ? e?.auditDate : e.updatedDate)}</>}
									header="Effective Date"
									sortable
								></Column>
								<Column
									style={{
										overflow: "visible" // Set overflow to visible to prevent hidden content
									}}
									field="application.applicationType"
									header="Application Type"
									sortable
								></Column>
								<Column
									style={{ width: "100px" }}
									field="active"
									header="Eligibility Status"
									body={(e) => (e?.eligibleStatus == "Y" ? "Eligible" : "Not Eligible")}
									sortable
								></Column>
								<Column
									field="active"
									header="Record Status"
									body={(e) =>
										e?.active === true ? (
											<Badge value="Active" severity="success" />
										) : (
											<Badge value="Not Active" severity="danger" />
										)
									}
								/>
								{/* <Column
							style={{ width: "100px" }}
							field="active"
							header="Record Status"
							body={(e) =>
								e?.active === true ? (
									<Button
										label="Active"
										style={{ textAlign: "center", height: "30px" }}
										className="p-button-success p-button-rounded"
									/>
								) : (
									<Button
										label="Not Active"
										style={{ textAlign: "center", height: "30px" }}
										className="p-button-danger p-button-rounded"
									/>
								)
							}
							sortable
						></Column> */}

								<Column
									field="action"
									header="Action"
									body={(item) => (
										<>
											<Button
												onClick={() => {
													setSelectedItem(item);
													setShowDialog(true);
												}}
												tooltip="Click to View"
												icon={"pi pi-eye"}
												tooltipOptions={{ position: "top" }}
												className=" p-button-rounded mr-2"
												style={{
													textAlign: "center",
													width: "30px",
													height: "30px"
												}}
											/>
											{item?.active && (
												<Button
													onClick={() => {
														// setSelectedItem(item);
														console.log(item)
														onGenerateRport(true, item.voterID);

													}}
													tooltip="Click to Print"
													icon={"pi pi-print"}
													tooltipOptions={{ position: "top" }}
													className="p-button-success p-button-rounded mr-2"
													style={{
														textAlign: "center",
														width: "30px",
														height: "30px"
													}}
												/>
											)}
										</>
									)}
								></Column>
							</DataTable>
						</TabPanel>
						<TabPanel header={header("Applications")}>
							<DataTable
								size="small"
								scrollable={true}
								value={applications}
								loading={loading}
								dataKey="applicationID"
								// paginator
								//rows={query.pageSize} // Use limit from query model
								//totalRecords={totalRecords}
								//onPage={onPageChange}
								//rowsPerPageOptions={[10, 25, 50]}
								className="datatable-responsive"
								//currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
								emptyMessage="No data found."
								responsiveLayout="scroll"
								resizableColumns
								columnResizeMode="expand"
								onSelectionChange={(e) => setSelectedApplication(e.value)}
								//selection={selectedItems}
								selectionPageOnly={true}
								//filters={filters}
								globalFilterFields={[
									"referenceNumber",
									"idNumber",
									"applicationDate",
									"applicationType.name",
									"applicationStatus.name"
								]}
							// filterDisplay="row"
							>
								<Column field="referenceNumber" header="Reference No." sortable filter filterPlaceholder="Search"></Column>
								<Column field="idNumber" header="National ID" sortable filter filterPlaceholder="Search"></Column>
								<Column
									field="applicationDate"
									header="Application Date"
									sortable
									body={(rowData) => formatDate(rowData.applicationDate?.split(" ")[0])}
								/>
								{/* <Column field="applicationChannel.name" header="Channel" sortable /> */}
								<Column field="applicationType" header="Type" sortable />

								<Column field="applicationStatus" header="Status" sortable />

								{columnConfigs[selectedType?.name]?.map((col) => (
									<Column key={col.field} field={col.field} header={col.header} sortable />
								))}

								<Column
									field="actions"
									header="Actions"
									body={(rowData) => (
										<>
											<Button
												style={{ textAlign: "center", width: "30px", height: "30px" }}
												icon={"pi pi-eye"}
												tooltipOptions={{ position: "top" }}
												className="p-button-primary p-button-rounded mr-2"
												tooltip="Click to View"
												onClick={() => {
													setSelectedApplication(rowData);
													setShowApplication(true);
												}}
											/>
											<Button
												onClick={() => {
													// setSelectedItem(item);
													console.log(rowData)
													setApplicationID(rowData.applicationID)
													setReportShowDialog(true);
													setCurrentReport("applicant");

												}}
												tooltip="Click to Print"
												icon={"pi pi-print"}
												tooltipOptions={{ position: "top" }}
												className="p-button-success p-button-rounded mr-2"
												style={{
													textAlign: "center",
													width: "30px",
													height: "30px"
												}}
											/>
										</>
									)}
								></Column>
							</DataTable>
							{selectedApplication && (
								<ViewApplication
									applicationID={selectedApplication?.applicationID}
									referenceNumber={selectedApplication?.referenceNumber}
									applicationTypeID={selectedApplication?.applicationType?.applicationTypeID}
									idNumber={selectedApplication?.idNumber}
									visible={showApplication}
									onHide={onHideApplication}
								/>
							)}
						</TabPanel>
					</TabView>

					{showDialog && (
						<VoterDialog
							voter={selectedItem}
							visible={showDialog}
							loading={loading}
							setLoading={setLoading}
							onHide={() => {
								setShowDialog(false);
								setSelectedItem(null);
							}}
						></VoterDialog>
					)}
				</div>
			</div>
		</div>
	);
};
